import { useQuery } from 'react-query'
import { getTalents, getTalentByUrl, getTalentByCode } from 'services/requests/talents'
import { useGetResourcesByUrlArray } from './base'
import { Voice } from 'types/Voice'


export const useGetTalents = (params) => {
	const defaultParams = {
		page: 1,
		itemsPerPage: 30
	}

	return useQuery(
		['talents', {...defaultParams, ...params}],
		() => getTalents({...defaultParams, ...params})
	)
}

export const useGetTalentByUrlArray = ( voices ) => {
	return useGetResourcesByUrlArray<Voice>(getTalentByUrl, voices)
}

export const useGetTalentByCode = ( code ) => {
	return useQuery(['talent', code],() => getTalentByCode(code))
}
